module.exports = __webpack_public_path__ + "img/usability.bad296ef.png";